import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DifineworkflowComponent } from './difineworkflow.component';

const routes: Routes = [{ path: '', component: DifineworkflowComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DifineworkflowRoutingModule { }
